import { cameraStreamManager } from 'services/CameraStream/CameraStreamManager';

const prevHiddenCamsByTransaction = {};

export const handleHiddenCameras = (level1, id) => {
    const currentHiddenIds = level1.filter((cam) => cam.hidden).map((cam) => cam.id);
    const prevHiddenIds = prevHiddenCamsByTransaction[id] || [];
    const newlyHiddenIds = currentHiddenIds.filter((id) => !prevHiddenIds.includes(id));
    const uniqueNewlyHiddenIds = Array.from(new Set(newlyHiddenIds));
    prevHiddenCamsByTransaction[id] = currentHiddenIds;

    if (uniqueNewlyHiddenIds.length) {
        uniqueNewlyHiddenIds.forEach((id) => {
            cameraStreamManager.removeVideoOutput(cameraStreamManager.getVideoElementId('wall', id), false);
        });
    }
};
